var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sorting" }, [
    _c("div", { staticClass: "sorting__title" }, [
      _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
    ]),
    _vm._v(" "),
    _vm.sort
      ? _c(
          "div",
          { staticClass: "sorting__buttons" },
          _vm._l(_vm.sort, function (item, index) {
            return _c(
              "button",
              {
                key: index,
                class: { active: item.value === _vm.isActive },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.selectThis(item.value)
                  },
                },
              },
              [_vm._v("\n      " + _vm._s(item.name) + "\n    ")]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }